/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

import './dep-6f3e4f56.mjs';

/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */
function isNull(value) {
  return value === null;
}
var isNull_1 = isNull;

export { isNull_1 as i };
//# sourceMappingURL=dep-c45cdd10.mjs.map
